import api from './api';

// Performans kurulum verisi (yetkinlik, skala, hedef şablonu, pozisyon
// yetkinliği, kişi hedefi) tek çok sayfalı Excel ile yüklenir.
//
// execute, validate ile AYNI dosyayı yeniden gönderir: sunucu tarafında geçici
// dosya saklanmaz (çok podlu ortamda validate ve execute farklı podlara
// düşebilir). Bu yüzden seçilen File nesnesi kaydedilene kadar state'te tutulur.
export const getPerformanceImportTemplate = () =>
  api.get('/v1/performance-import/template', { responseType: 'blob' });

const upload = (path, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(path, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const validatePerformanceImport = (file) =>
  upload('/v1/performance-import/validate', file);

export const executePerformanceImport = (file) =>
  upload('/v1/performance-import/execute', file);
